import { Action, createReducer, on } from '@ngrx/store'
import { ActivityState, initialActivityState } from '../state/activity.state'
import {
  DELETE_ACTIVITY_DETAILS,
  FETCH_ACTIVITY_DETAILS_SUCCESS,
  LOAD_ACTIVITY_SUMMARY_DETAILS_SUCCESS,
  fetch_activity_dashboard_data_success
} from '../action/activity.action'
import { ActivityDashboardModel } from 'src/app/models/model'

export function activityReducer(state: ActivityState, action: Action) {
  return _activityReducer(state, action)
}

const _activityReducer = createReducer(
  initialActivityState,
  on(fetch_activity_dashboard_data_success, (state, { activityItemsList, statusCountMap }) => {
    const dashboardData: ActivityDashboardModel = {
      activityItemsList: activityItemsList,
      statusCountMap: statusCountMap
    }
    return {
      ...state,
      dashboard: dashboardData
    }
  }),
  on(FETCH_ACTIVITY_DETAILS_SUCCESS, (state, { activity }) => {
    return {
      ...state,
      details: activity
    }
  }),
  on(DELETE_ACTIVITY_DETAILS, (state, {}) => {
    return {
      ...state,
      details: null
    }
  }),
  on(LOAD_ACTIVITY_SUMMARY_DETAILS_SUCCESS, (state, data) => {
    return {
      ...state,
      summary: data
    }
  })
)
